import { getAlgoliaProductIndex } from "@utils/configuration/aem";

import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";
import { ProductImpressionTrackingInfo } from "@services/tracking";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents,
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaClickPayload,
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsProductClickImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaClickPayload> {}

const getAlgoliaProductClickPayload = (
    eventData: ProductImpressionTrackingInfo,
): AlgoliaClickPayload => {
    const lastQueryRecord = AlgoliaTrackingService.getLastQueryTrackRecordFor(
        eventData.id,
    );

    return {
        authenticatedUserToken:
            AlgoliaTrackingService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.HitClicked,
        index: getAlgoliaProductIndex(),
        userToken: AlgoliaTrackingService.getUserToken(),
        queryID: lastQueryRecord?.queryID,
        objectIDs: [eventData.id],
        positions: lastQueryRecord?.position
            ? [lastQueryRecord?.position]
            : undefined,
    };
};

const getAlgoliaAnalyticsProductClickImpression = (
    data: TypedAnalyticsEvent<ProductImpressionTrackingInfo>,
): Array<AlgoliaAnalyticsProductClickImpression> => {
    const payload = getAlgoliaProductClickPayload(data.payload.eventData);

    return [
        {
            eventName: payload.queryID
                ? AlgoliaAnalyticsEvents.ClickedObjectIDsAfterSearch
                : AlgoliaAnalyticsEvents.ClickedObjectIDs,
            payload: payload,
        },
    ];
};

export { getAlgoliaAnalyticsProductClickImpression };
